import { useEffect } from "react";
import { CustomError } from "@skv/core";
import { useSelector } from "react-redux";

import { RootState, useThunkDispatch } from "../";

import { fetchOrganisation } from "./actions";

export const useOrganisation = (id: string) => {
  const dispatch = useThunkDispatch();
  const organisationState = useSelector(
    (state: RootState) => state.organisation
  );

  const organisation = organisationState.data[id];

  useEffect(() => {
    dispatch(fetchOrganisation(id));
  }, [id, dispatch]);

  if (organisation instanceof CustomError) {
    return {
      ...organisationState,
      loading: false,
      error: organisation,
      data: null,
    };
  }

  return {
    ...organisationState,
    data: organisation,
  };
};
